<template>
  <layout-dashboard>
    <div class="row">
      <div class="col-md-12 pb-0">
        <h4 class="mb-4">Comisión por recargar: {{ rechargeData.name }}</h4>
      </div>

      <!-- RechargeCommission -->
      <div class="col-md-12 pt-0">
        <div class="card">
          <div class="card-body">
            <form
              @submit.prevent="update"
              method="POST"
              class="p-5 col-sm-10 mx-auto"
            >
              <div class="form-group row">
                <label class="col-md-4 col-form-label">Tipo de comisión</label>
                <div class="col-md-8">
                  <select
                    v-model="rechargeComissionData.commission_type_id"
                    class="custom-select"
                  >
                    <option
                      v-for="(value, key) in commission_types"
                      v-bind:key="key"
                      :value="value.id"
                      >{{ value.display_name }}</option
                    >
                  </select>
                  <small v-if="errors.commission_type_id" class="text-danger">{{
                    errors.commission_type_id[0]
                  }}</small>
                  <small v-else
                    >Selecciona el tipo de comisión si porcentaje o fijo</small
                  >
                </div>
              </div>

              <div class="form-group row">
                <label class="col-md-4 col-form-label"
                  >Monto de la comisión</label
                >
                <div class="col-md-8">
                  <input
                    v-model="rechargeComissionData.value"
                    type="number"
                    class="form-control"
                    min="0"
                    step="any"
                  />
                  <small v-if="errors.value" class="text-danger">{{
                    errors.value[0]
                  }}</small>
                  <small v-else>Introduce la cantidad total a cobrar</small>
                </div>
              </div>

              <div class="submit-section submit-btn-bottom">
                <button type="submit" class="btn btn-primary">
                  Guardar
                </button>
                <button
                  type="button"
                  class="btn btn-secondary ml-1"
                  @click="routeToRechargeCommissions()"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- /RechargeCommission -->
    </div>
  </layout-dashboard>
</template>

<script>
import { EventBus } from "@/main";
import global from "@/helpers/global";

export default {
  data() {
    return {
      rechargeData: {
        id: "",
        name: "",
      },
      rechargeComissionData: {
        recharge_way_id: "",
        commission_type_id: "",
        value: "",
      },
      commission_types: [],
      errors: [],
    };
  },
  mixins: [global],
  beforeMount() {
    this.getCommissionTypes();

    if (this.$route.params.id) {
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/api/v1/recharge-way/get/" +
            this.$route.params.id
        )
        .then((response) => {
          //console.log(response.data.recharge_way);
          this.rechargeData = response.data.recharge_way;
          this.rechargeComissionData = {
            recharge_way_id: this.rechargeData.id,
            commission_type_id: this.rechargeData.system_commission
              ? this.rechargeData.system_commission.commission_type_id
              : "",
            value: this.rechargeData.system_commission
              ? this.rechargeData.system_commission.value
              : "",
          };
          //console.log(response.data.message);
        })
        .catch((error) => {
          this.errors = [];
          this.errors = error.response.data.errors ?? [];

          EventBus.$emit("showErrors", {
            msg: error.response.data.error,
          });

          console.log(error.response.data.error);
        });
    }
  },
  mounted() {},
  methods: {
    routeToRechargeCommissions: function() {
      localStorage.setItem("commissionActiveTab", "#recharge");

      const _self = this;
      setTimeout(function() {
        _self.$router.push("/commissions");
      }, 3000);
    },
    update: function() {
      axios
        .put(
          process.env.VUE_APP_API_URL + "/api/v1/commission/recharge/update",
          this.rechargeComissionData
        )
        .then((response) => {
          EventBus.$emit("showInfo", {
            msg: response.data.message,
          });

          this.routeToRechargeCommissions();

          //console.log(response.data.message);
        })
        .catch((error) => {
          this.errors = [];
          this.errors = error.response.data.errors ?? [];

          EventBus.$emit("showErrors", {
            msg: error.response.data.error,
          });

          console.log(error.response.data.error);
        });
    },
  },
};
</script>
